import './style/app.scss'


(async () => {
  $('.play-btn').click(function () {
    $('.app-header .video-mask').show()
    $('.app-header .video-mask video').attr('src', 'https://static.qifeizn.com/resources/os/videos/APP-Video.mp4');
  })
  $('.app-header .video-close').click(function () {
    $('.app-header .video-mask').hide()
    $('.app-header .video-mask video').attr('src', '');
  })

  const { Swiper, Navigation, Autoplay, Pagination, Virtual } = await import(/* webpackChunkName: "swiper" */ 'swiper')
  Swiper.use([Navigation, Pagination, Autoplay, Virtual,])
  new Swiper('.swiper2', {
    direction: "vertical",
    pagination: {
      clickable: true,
      // type: 'progressbar',
      bulletClass: 'my-bullet',
      bulletActiveClass: 'my-bullet-active',
      el: '.swiper-pagination2',
      renderBullet: function (index, className) {
        let text, title;
        switch (index) {
          case 0:
            title = 'M+半自动智能作业功能'
            text = '让临时小地块也能精准高效作业。'
            break;
          case 1:
            title = '自动扫边功能'
            text = '满足更多场景作业需求，不放过每一个边角作物。'
            break;
          case 2:
            title = '地块切割功能'
            text = '可自定义切割所圈地块。'
            break;
          case 3:
            title = 'AB点角度调节功能'
            text = '让不规则地块也轻松快速精准作业。'
            break;
        }
        return `<div class="${className}">
          <div>${title}</div>
          <div class="subtitle">${text}</div>
        </div>`
      }
    }
  })

  new Swiper('.custom-swiper',{
    // autoplay: {
    //   delay: 5000,
    //   stopOnLastSlide: false,
    //   disableOnInteraction: true,
    // },
  })



  $('.icon-pagination li').hover(function () {
    swiper1.slideTo($(this).index() + 1, 1000, false);
    $(this).addClass('active')
    $(this).siblings().removeClass('active')
  })

  $('.efficient-operation ul li').hover(function () {
    swiper2.slideTo($(this).index() + 1, 1000, false);
    $(this).addClass('active')
    $(this).siblings().removeClass('active')
  })

})()


const slides = [...document.querySelectorAll('.slide')].reverse()
let index = 0

const nextSlide = (index) => {
  // if(index === slides.length){

  // }
  let firstElement = slides.shift();
  slides.push(firstElement);


  for (let i = 0; i < slides.length; i++) {
    const element = slides[i];
    element.style.left = i * 80 + 'px'
    element.style.top = -(i * 60) + 'px'
    element.style.zIndex = slides.length - i
    if(i === 0){
      element.style.opacity = 1
    }else{
      element.style.opacity = 0.9
    }
  }
}

nextSlide()

setInterval(() => {
  if (index <= slides.length - 1) {
    index++
  } else {
    index = 0
  }
  nextSlide()
}, 4000)


$('.video-button').click(function () {
  var url = $(this).attr('dataId')
  $('.video-mask').show()
  $('.video-mask video').attr('src', url);
})
$('.video-close').click(function () {
  $('.video-mask').hide()
  $('.video-mask video').attr('src', '');
})